var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmationCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 136 124",
    style: {
      enableBackground: "new 0 0 136 124"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFFCFC;}\n\t.st1{opacity:0.7;enable-background:new    ;}\n\t.st2{fill:#028383;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.8,2.3c0,0-23.2-7.1-44.5,6.8C21,23.1,11.6,49.2,3.4,70.2c-8.2,21-1.2,41.7,16.5,50.5 c17.6,8.8,28.2-5.8,51.9-7.5s30.4,1.4,49.2-13c18.8-14.5,20.1-46.7,2.9-69.7C106.6,7.4,86.8,2.3,86.8,2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.8,2.3c0,0-23.2-7.1-44.5,6.8C21,23.1,11.6,49.2,3.4,70.2c-8.2,21-1.2,41.7,16.5,50.5 c17.6,8.8,28.2-5.8,51.9-7.5s30.4,1.4,49.2-13c18.8-14.5,20.1-46.7,2.9-69.7C106.6,7.4,86.8,2.3,86.8,2.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 85,
    className: "st2",
    width: 85,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.5,74.6l3.5-4.8l-5.3-1.6l0.8-2.6l5.3,1.9l-0.2-6h2.7l-0.2,6.1l5.2-1.9l0.8,2.7L32.9,70l3.5,4.7l-2.2,1.6 l-3.3-5l-3.2,4.9L25.5,74.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.5,74.6l3.5-4.8l-5.3-1.6l0.8-2.6l5.3,1.9l-0.2-6h2.7l-0.2,6.1l5.2-1.9l0.8,2.7L57.9,70l3.5,4.7l-2.2,1.6 l-3.3-5l-3.2,4.9L50.5,74.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.5,74.6l3.5-4.8l-5.3-1.6l0.8-2.6l5.3,1.9l-0.2-6h2.7l-0.2,6.1l5.2-1.9l0.8,2.7L81.9,70l3.5,4.7l-2.2,1.6 l-3.3-5l-3.2,4.9L74.5,74.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.5,74.6l3.5-4.8l-5.3-1.6l0.8-2.6l5.3,1.9l-0.2-6h2.7l-0.2,6.1l5.2-1.9l0.8,2.7l-5.4,1.6l3.5,4.7l-2.2,1.6 l-3.3-5l-3.2,4.9L99.5,74.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationCode);
export default __webpack_public_path__ + "static/media/confirmationCode.954f00fdf214c7b540fa551c45fd531b.svg";
export { ForwardRef as ReactComponent };